import { ActionIcon, Tooltip } from "@mantine/core";
import { IconSortAscending, IconSortDescending } from "@tabler/icons-react";

interface Props {
  sortAscending: boolean;
  onToggleSort: () => void;
}

const NMEASortButton = ({ sortAscending, onToggleSort }: Props) => {
  return (
    <Tooltip
      label={sortAscending ? "Sort newest to oldest" : "Sort oldest to newest"}
      withArrow>
      <ActionIcon variant="outline" size={28} onClick={onToggleSort}>
        {sortAscending ? (
          <IconSortAscending size={16} />
        ) : (
          <IconSortDescending size={16} />
        )}
      </ActionIcon>
    </Tooltip>
  );
};

export default NMEASortButton;
